// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"2047f74d","769":"8cf07026"}[chunkId] + ".chunk.js";
};